export const reverseDate = (date: string) =>
  date?.split('-').reverse().join('-');

export const getGender = (gender: string) => (gender === 'male' ? 'VM' : 'VV');

export const getGenderFromInitials = (gender: string) =>
  gender === 'VM' ? 'male' : 'female';

export const getPartnerData = (partner: {
  birthDate: string;
  gender: string;
}) => {
  if (!partner.gender || !partner.birthDate) {
    return [];
  }

  return [
    {
      genderOrLegalPersonType: getGender(partner.gender),
      birthDate: reverseDate(partner.birthDate),
    },
  ];
};

export const getChildrenData = (data) => {
  const birthdateValues = data.filter((child) =>
    child?.name.includes('childBirthdate')
  );
  const genderValues = data.filter((child) =>
    child?.name.includes('childGender')
  );

  const result = birthdateValues.map((child, index: number) => ({
    birthDate: reverseDate(child?.value),
    genderOrLegalPersonType: getGender(genderValues[index]?.value),
  }));

  return result;
};

export const transformCoverages = (coverages) =>
  coverages.map((coverage) => ({
    key: coverage.name,
    level: Array.isArray(coverage.value) ? coverage.value[0] : coverage.value,
  }));

export const getDocuments = (
  coverageBasicHealths,
  _coverageAdditionalHealths,
  _coverageDentistHealths
) => {
  const basicDocs = coverageBasicHealths?.documents || [];
  // const additionalDocs = coverageAdditionalHealths?.documents || [];
  // const dentistDocs = coverageDentistHealths?.documents || [];

  return [...basicDocs].filter(({ attachmentType }) => Boolean(attachmentType));
};

export const getPolicyDetails = (
  data,
  { clientId, sessionId },
  paymentTermInMonths = 1
) => {
  const {
    deductibleAmount,
    birthDate,
    postalCode,
    gender,
    partner,
    children,
    coverages,
    partyCaregivers,
    currentlyStudying,
    customProperties,
  } = data;

  const isStudent = currentlyStudying === '1' ? true : false;

  return {
    policy: {
      paymentTermInMonths: paymentTermInMonths,
      coverageBasicHealths: [
        {
          deductibleAmount: deductibleAmount || 385,
        },
      ],
      partyPolicyHolders: [
        {
          addresses: [
            {
              postalCode,
            },
          ],
          genderOrLegalPersonType: getGender(gender),
          birthDate: reverseDate(birthDate),
          partyPartners: getPartnerData(partner),
          partyChildren: getChildrenData(children),
          ...(currentlyStudying && { currentlyStudying: isStudent }),
        },
      ],
      healthAdditionalCoverages:
        coverages.length > 0 ? transformCoverages(coverages) : {},
      partyCaregivers,
      customProperties
    },
    sessionId,
    clientId,
  };
};

export const getAcceptanceValues = (additions, dentists) => {
  let finalArr: any[] = [];

  if (
    Array.isArray(additions) &&
    Array.isArray(additions[0]?.acceptanceValues)
  ) {
    finalArr.push(...additions[0].acceptanceValues);
  }

  if (Array.isArray(dentists) && Array.isArray(dentists[0]?.acceptanceValues)) {
    finalArr.push(...dentists[0].acceptanceValues);
  }

  return finalArr;
};

export const generateUUID = (): string => {
  let d = new Date().getTime(); //Timestamp
  let d2 =
    (typeof performance !== 'undefined' &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = self.crypto.getRandomValues(new Uint32Array(1))[0] % 17;
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const getCookie = (cookieName) => {
  let cookie = {};
  document.cookie.split(';').forEach((el) => {
    let [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};

export const setCookie = (name, value, minutes) => {
  const expires = new Date(Date.now() + minutes * 60000).toUTCString();
  document.cookie =
    name +
    '=' +
    encodeURIComponent(value) +
    '; expires=' +
    expires +
    '; path=/';
};
